import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, EnvironmentModel } from '@fh-client-interaction-frontends/fh-app-config';
import { HttpClient } from '@angular/common/http';
import { AdhesionPaymentModel } from '@fh-client-interaction-frontends/fh-data-access-adhesion';

@Injectable({
  providedIn: 'root'
})
export class CompanyAdhesionService {
  appConfig: EnvironmentModel = new EnvironmentModel();

  constructor(private http: HttpClient, @Inject(APP_CONFIG) protected appConfigTemp: EnvironmentModel) {
    this.appConfig = appConfigTemp;
  }

  createCompany(body: any) {
    const url: string = this.appConfig.api + 'contracts/' + this.appConfig.apiPartnershipId + '/companies';
    return this.http.post<any>(url, body);
  }
}
